import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import { isGroupInFavorites } from 'owa-favorites';
import { getGroupsStore } from 'owa-groups-shared-store';
import { getLeftNavGroupsStore } from 'owa-group-left-nav';
export default function getFavoriteGroupSuggestions(searchTerm) {
    var groupsStore = getGroupsStore();
    var leftNavGroupsStore = getLeftNavGroupsStore();
    var lowerCaseSearchTerm = searchTerm.toLocaleLowerCase();
    // First lets build an array with the Group Information for all the non favorite Groups. This array
    // will be sorted in prankie order because that is the order of myOrgGroups.
    var favoriteGroupsSuggestion = leftNavGroupsStore.myOrgGroups
        .filter(function (groupId) {
        return !isGroupInFavorites(groupId);
    })
        .map(function (groupId) {
        return groupsStore.groups.get(groupId).basicInformation;
    });
    // If a search term was provided, lets reduce the suggestions to only those containing the search term.
    // When no search term is provided, we will show the Groups in prankie order.
    if (searchTerm != '') {
        favoriteGroupsSuggestion = favoriteGroupsSuggestion.filter(function (group) {
            return (group.DisplayName.toLowerCase().indexOf(lowerCaseSearchTerm) >= 0 ||
                group.SmtpAddress.toLowerCase().indexOf(lowerCaseSearchTerm) >= 0);
        });
        sortByDisplayNamePrefixMatch(favoriteGroupsSuggestion, lowerCaseSearchTerm);
    }
    // Now lets reduce the result set to the maximum allowed for Groups
    favoriteGroupsSuggestion.splice(getMaxFavoriteSuggestionCounts().group);
    return favoriteGroupsSuggestion.map(function (group) {
        return {
            data: group.DisplayName,
            id: group.SmtpAddress,
            type: 4 /* Group */,
            relevance: 0,
        };
    });
}
function sortByDisplayNamePrefixMatch(array, searchTerm) {
    array.sort(function (group1, group2) {
        var group1DisplayName = group1.DisplayName.toLowerCase();
        var group2DisplayName = group2.DisplayName.toLowerCase();
        var group1DisplayNamePrefixMatch = group1DisplayName.indexOf(searchTerm) == 0;
        var group2DisplayNamePrefixMatch = group2DisplayName.indexOf(searchTerm) == 0;
        // Sort array so that Groups with Display Name prefix match show up first
        if (group1DisplayNamePrefixMatch && !group2DisplayNamePrefixMatch) {
            return -1;
        }
        else if (!group1DisplayNamePrefixMatch && group2DisplayNamePrefixMatch) {
            return 1;
        }
        else {
            // If we don't have a prefix match for the display name, we will keep the results sorted by prankie order
            return 0;
        }
    });
}
//# sourceMappingURL=getFavoriteGroupSuggestions.js.map